module.exports = __webpack_public_path__ + "static/media/demo_3.deefb986.mp4";